export default {
  path: '/admins',
  component: () => import(
    /* webpackChunkName: "admins-list" */
    /* webpackPrefetch: true */
    './List'
  ),
  children: [
    {
      path: 'create',
      component: () => import(
        /* webpackChunkName: "admins-create" */
        /* webpackPrefetch: true */
        './Create'
      ),
    },
    {
      path: ':id',
      component: () => import(
        /* webpackChunkName: "admins-detail" */
        /* webpackPrefetch: true */
        './Detail'
      ),
    },
  ],
};
